import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';


import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { NotificationsService } from 'src/app/services/notifications/notifications.service';
import { L10nPipe } from 'src/app/helpers/pipes/L10n.pipe';

import { Notification } from 'src/app/shared/models/notification.model';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    imports: [L10nPipe],
    animations: [
        trigger('enterAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(100%)', opacity: 0 }),
                animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateX(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateX(100%)', opacity: 0 }))
            ])
        ])
    ],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  public notifications: Array<Notification> = [];

  private notificationsSub: Subscription;

  constructor(private notificationsService: NotificationsService) {}

  ngOnInit(): void {
    this.notificationsSub = this.notificationsService.$notifications
      .pipe(
        tap((notifications: Notification[]) => {
          this.notifications = notifications;
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.notificationsSub.unsubscribe();
  }

  dismissNotification(id): void {
    this.notificationsService.dismissNotification(id);
  }

  handleActionClick(e, item: Notification): void {
    if (item.config.action.handler) {
      item.config.action.handler(item);
      this.dismissNotification(item.id);

      e.stopPropagation();
    }
  }
}
